import React, { useState } from 'react';
import { Loader2 } from 'lucide-react';
import { toast } from 'sonner';
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from '../ui/AlertDialog';
import { useStudents } from '../../contexts/StudentsContext';
import type { Student } from '../../types/student';
import { describeSupabaseError } from '../../utils/supabase';
interface DeleteStudentDialogProps {
  student: Student | null;
  onClose: () => void;
}
export function DeleteStudentDialog({
  student,
  onClose
}: DeleteStudentDialogProps) {
  const {
    removeStudent
  } = useStudents();
  const [deleting, setDeleting] = useState(false);
  const handleDelete = async () => {
    if (!student) return;
    setDeleting(true);
    try {
      await removeStudent(student);
      toast.success('Student record deleted', {
        description: student.fullNames.trim() || 'Untitled record'
      });
      onClose();
    } catch (error) {
      toast.error('Could not delete the record', {
        description: describeSupabaseError(error)
      });
    } finally {
      setDeleting(false);
    }
  };
  return <AlertDialog open={Boolean(student)} onOpenChange={open => open ? undefined : onClose()} data-id="element-243" data-mp="3f5pi23mez55f">
      <AlertDialogContent className="glass-strong rounded-3xl" data-id="element-244" data-mp="3a74scy4sg3v8">
        <AlertDialogHeader data-id="element-245" data-mp="3a6mkt5coe380">
          <AlertDialogTitle data-id="element-246" data-mp="357ry3sbl7uim">Delete this student record?</AlertDialogTitle>
          <AlertDialogDescription data-id="element-247" data-mp="359wayzrgs3v1">
            {student?.fullNames.trim() || 'This record'} will be permanently removed from your school database. This
            cannot be undone.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter data-id="element-248" data-mp="2rgwscowdxtj9">
          <AlertDialogCancel disabled={deleting} className="rounded-xl" data-id="element-249" data-mp="2rhoi3j3awx1m">
            Cancel
          </AlertDialogCancel>
          <AlertDialogAction onClick={event => {
          event.preventDefault();
          void handleDelete();
        }} disabled={deleting} className="rounded-xl bg-destructive text-white hover:opacity-90" data-id="element-250" data-mp="2mjeimwajnaa7">
            {deleting && <Loader2 className="mr-2 h-4 w-4 animate-spin" data-id="element-251" data-mp="2cuzhtf186fu6" />}
            {deleting ? 'Deleting…' : 'Delete record'}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>;
}